<template functional>
  <div class="productpage__social">
    <ul class="share-btns">
      <li>
        <a
          class="share-btns__btn share-btns__btn--facebook"
          target="_blank"
          :href="`https://www.facebook.com/sharer.php?u=${$options.sharedUrl(
            parent
          )}`"
        >
          <facebook-icon color="#999" />
        </a>
      </li>
      <li>
        <a
          class="share-btns__btn share-btns__btn--twitter"
          target="_blank"
          :href="`https://twitter.com/share?url=${$options.sharedUrl(
            parent
          )}&amp;text=${parent.$t(
            'social.share_before'
          )} ${$options.productName(parent)}&amp;hashtags=gocase`"
        >
          <twitter-icon color="#999" />
        </a>
      </li>
      <li>
        <a
          class="share-btns__btn share-btns__btn--pinterest"
          target="_blank"
          :href="`https://www.pinterest.com/pin/create/btn/?url=${$options.sharedUrl(
            parent
          )}&amp;media=${$options.previewImage(parent)};description=${parent.$t(
            'social.share_before'
          )} ${$options.productName(parent)}`"
        >
          <pinterest-icon color="#999" />
        </a>
      </li>
      <li class="share-btns__item--whatsapp">
        <a
          class="share-btns__btn share-btns__btn--whatsapp"
          target="_blank"
          :href="`https://wa.me?text=${parent.$t(
            'social.share_before'
          )} ${$options.sharedUrl(parent)}`"
        >
          <whatsapp-icon color="#555555" second-color="#ddd" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from 'vue'

import PinterestIcon from '~/components/icons/social/pinterest/Pinterest'
import TwitterIcon from '~/components/icons/social/twitter/Twitter'
import FacebookIcon from '~/components/icons/social/facebook/Facebook'
import WhatsappIcon from '~/components/icons/social/whatsapp/Whatsapp'

Vue.component('pinterest-icon', PinterestIcon)
Vue.component('twitter-icon', TwitterIcon)
Vue.component('facebook-icon', FacebookIcon)
Vue.component('whatsapp-icon', WhatsappIcon)

export default {
  name: 'ShareProduct',
  sharedUrl(parent) {
    return `https://${parent.$store.state?.siteStore?.urls?.production}${parent.$route.path}`
  },
  previewImage(parent) {
    return parent.$store.state?.product?.product?.images[0]?.url
  },
  productName(parent) {
    return parent.$store.state?.product?.product?.name
  },
}
</script>

<style lang="scss">
.share-btns {
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: center;
}

.share-btns li {
  display: inline-block;
  vertical-align: top;
}

.share-btns__btn {
  background: $v4_color_line_lighter;
  border-radius: 4px;
  color: #999;
  text-decoration: none;
  font-size: 16px;
  margin-right: 16px;
  margin-left: 16px;
  width: 48px;
  height: 48px;
  text-align: center;
  box-sizing: border-box;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 16px;
  }

  &:hover {
    background: #ddd;
  }
}

.share-btns__btn--wanelo,
.share-btns__btn--whatsapp {
  line-height: 16px;
}

.social_wanelo,
.social_whatsapp {
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  width: 16px;
  height: 16px;
  display: inline-block;
  margin-left: 1px;
}

.social_wanelo {
  background-image: image-url(
    '~@/assets/images/icons/icons-regular/icon-wanelo.png'
  );
}
.social_whatsapp {
  background-image: image-url(
    '~@/assets/images/icons/icons-regular/icon-whatsapp.png'
  );
}

@media (min-width: $screen_large) {
  html .share-btns__item--whatsapp {
    display: none;
  }
}
</style>
